import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f7d628e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "line-name-wrapper" }
const _hoisted_4 = { class: "name-chip-wrapper" }
const _hoisted_5 = { class: "line-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "line-info_wrapper",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitOnClickLineInfo($props.lineInfo))),
    "aria-label": `노선 상세: ${$setup.useGetLineRouteName(
      $props.lineInfo.lineTypeCode,
      $props.lineInfo.name,
      $props.lineInfo.no
    )}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["LineSetTypeChip"], {
          lineTypeCode: $props.lineInfo.lineTypeCode,
          lineTypeName: $props.lineInfo.lineTypeName,
          lineTurns: $props.lineInfo.turns
        }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName", "lineTurns"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.useGetLineRouteName(
                $props.lineInfo.lineTypeCode,
                $props.lineInfo.name,
                $props.lineInfo.no
              )), 1 /* TEXT */)
        ])
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}